import { useMemeStore, useBannerStore } from '../../stores';

interface UndoButtonProps {
  activeTab: 'memes' | 'banner';
}

export function UndoButton({ activeTab }: UndoButtonProps) {
  const memeCanUndo = useMemeStore((s) => s.canUndo);
  const memeUndo = useMemeStore((s) => s.undo);
  const bannerCanUndo = useBannerStore((s) => s.canUndo);
  const bannerUndo = useBannerStore((s) => s.undo);

  const canUndo = activeTab === 'memes' ? memeCanUndo : bannerCanUndo;
  const undo = activeTab === 'memes' ? memeUndo : bannerUndo;

  return (
    <button
      onClick={undo}
      disabled={!canUndo}
      title="Undo (Ctrl+Z)"
      className={`p-2 rounded-lg transition-all duration-150 ${
        canUndo
          ? 'text-text-muted dark:text-neutral-400 hover:text-text-dark dark:hover:text-white hover:bg-surface-secondary dark:hover:bg-neutral-700/50'
          : 'text-text-muted/30 dark:text-neutral-600 cursor-not-allowed'
      }`}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="1 4 1 10 7 10" />
        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
      </svg>
    </button>
  );
}
